var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeroKalinchenko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 54,
    viewBox: "0 0 148 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7435_11991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8501 11.68V12.91H41.9401L42.8201 11.68H43.4601L42.4201 12.97C42.8401 13.05 43.0101 13.32 43.1401 13.68C43.2501 13.98 43.3401 14.27 43.4601 14.54H42.9001C42.8001 14.34 42.7301 14.11 42.6601 13.89C42.5501 13.54 42.3901 13.29 41.9801 13.29H41.8601V14.54H41.3401V11.67H41.8601L41.8501 11.68Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9601 11.68V14.55H45.4401V12.11H44.6601V12.88C44.6601 13.57 44.6001 14.19 44.1801 14.45C44.0601 14.53 43.8701 14.59 43.6701 14.59L43.6101 14.17C43.7401 14.15 43.8501 14.09 43.9201 14.02C44.1201 13.82 44.1501 13.37 44.1501 12.92V11.69H45.9701L45.9601 11.68Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0501 11.68V12.69C47.0501 13.15 47.0401 13.57 47.0201 13.95C47.1701 13.63 47.3601 13.29 47.5401 12.96L48.3001 11.67H48.8301V14.54H48.3501V13.52C48.3501 13.07 48.3501 12.7 48.3901 12.33C48.2501 12.66 48.0601 13.02 47.8801 13.32L47.1601 14.53H46.5801V11.66H47.0601L47.0501 11.68Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9502 11.68V12.83H51.1702V11.68H51.6902V14.55H51.1702V13.28H49.9502V14.55H49.4302V11.68H49.9502Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7701 11.68V12.69C52.7701 13.15 52.7601 13.57 52.7401 13.95C52.8901 13.63 53.08 13.29 53.26 12.96L54.0201 11.67H54.55V14.54H54.07V13.52C54.07 13.07 54.0701 12.7 54.1101 12.33C53.9701 12.66 53.78 13.02 53.6 13.32L52.8801 14.53H52.3V11.66H52.78L52.7701 11.68Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6702 11.68V12.91H55.7602L56.6402 11.68H57.2802L56.2402 12.97C56.6602 13.05 56.8302 13.32 56.9602 13.68C57.0702 13.98 57.1602 14.27 57.2802 14.54H56.7202C56.6202 14.34 56.5502 14.11 56.4802 13.89C56.3702 13.54 56.2102 13.29 55.8002 13.29H55.6802V14.54H55.1602V11.67H55.6802L55.6702 11.68Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2202 13.74L57.9702 14.55H57.4302L58.3502 11.68H59.0202L59.9502 14.55H59.3902L59.1302 13.74H58.2202ZM59.0402 13.34L58.8102 12.63C58.7502 12.46 58.7102 12.26 58.6602 12.09C58.6202 12.26 58.5702 12.46 58.5202 12.63L58.3002 13.34H59.0402Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87 11.68V12.11H61.75V14.55H61.23V11.68H62.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6001 13.09C65.6001 14.05 65.0201 14.6 64.2201 14.6C63.4201 14.6 62.9001 13.98 62.9001 13.14C62.9001 12.3 63.4501 11.64 64.2601 11.64C65.0701 11.64 65.5901 12.27 65.5901 13.09M63.4501 13.13C63.4501 13.71 63.7401 14.18 64.2501 14.18C64.7601 14.18 65.0401 13.71 65.0401 13.11C65.0401 12.57 64.7701 12.06 64.2501 12.06C63.7301 12.06 63.4501 12.54 63.4501 13.13Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6001 13.09C65.6001 14.05 65.0201 14.6 64.2201 14.6C63.4201 14.6 62.9001 13.98 62.9001 13.14C62.9001 12.3 63.4501 11.64 64.2601 11.64C65.0701 11.64 65.5901 12.27 65.5901 13.09M63.4501 13.13C63.4501 13.71 63.7401 14.18 64.2501 14.18C64.7601 14.18 65.0401 13.71 65.0401 13.11C65.0401 12.57 64.7701 12.06 64.2501 12.06C63.7301 12.06 63.4501 12.54 63.4501 13.13Z",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.05 11.72C66.24 11.69 66.5 11.66 66.85 11.66C67.23 11.66 67.51 11.74 67.7 11.89C67.87 12.03 67.98 12.26 67.98 12.53C67.98 12.8 67.89 13.03 67.73 13.18C67.52 13.39 67.19 13.49 66.82 13.49C66.72 13.49 66.63 13.49 66.57 13.47V14.55H66.05V11.72ZM66.57 13.06C66.63 13.08 66.72 13.08 66.82 13.08C67.21 13.08 67.45 12.89 67.45 12.55C67.45 12.23 67.23 12.06 66.87 12.06C66.73 12.06 66.62 12.07 66.57 12.08V13.05V13.06Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7801 13.38C70.7601 13.01 70.7401 12.56 70.7501 12.17H70.7401C70.6501 12.52 70.5301 12.91 70.4001 13.27L69.9801 14.51H69.5801L69.2001 13.28C69.0901 12.91 68.9901 12.52 68.9101 12.16C68.9001 12.54 68.8801 12.99 68.8601 13.38L68.8001 14.53H68.3101L68.5001 11.66H69.1901L69.5601 12.81C69.6601 13.15 69.7501 13.49 69.8201 13.81H69.8301C69.9101 13.5 70.0001 13.14 70.1201 12.81L70.5201 11.66H71.2001L71.3701 14.53H70.8601L70.8001 13.36L70.7801 13.38Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4002 13.09C74.4002 14.05 73.8202 14.6 73.0202 14.6C72.2202 14.6 71.7002 13.98 71.7002 13.14C71.7002 12.3 72.2502 11.64 73.0602 11.64C73.8702 11.64 74.3902 12.27 74.3902 13.09M72.2502 13.13C72.2502 13.71 72.5402 14.18 73.0502 14.18C73.5602 14.18 73.8402 13.71 73.8402 13.11C73.8402 12.57 73.5702 12.06 73.0502 12.06C72.5302 12.06 72.2502 12.54 72.2502 13.13Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4002 13.09C74.4002 14.05 73.8202 14.6 73.0202 14.6C72.2202 14.6 71.7002 13.98 71.7002 13.14C71.7002 12.3 72.2502 11.64 73.0602 11.64C73.8702 11.64 74.3902 12.27 74.3902 13.09M72.2502 13.13C72.2502 13.71 72.5402 14.18 73.0502 14.18C73.5602 14.18 73.8402 13.71 73.8402 13.11C73.8402 12.57 73.5702 12.06 73.0502 12.06C72.5302 12.06 72.2502 12.54 72.2502 13.13Z",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3701 11.68V12.83H76.5801V11.68H77.1101V14.55H76.5801V13.28H75.3701V14.55H74.8501V11.68H75.3701Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28 13.74L78.03 14.55H77.49L78.41 11.68H79.08L80.01 14.55H79.45L79.19 13.74H78.28ZM79.1 13.34L78.87 12.63C78.82 12.46 78.77 12.26 78.73 12.09C78.69 12.26 78.65 12.46 78.59 12.63L78.37 13.34H79.11H79.1Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5502 11.68V14.55H82.0302V12.11H81.2502V12.88C81.2502 13.57 81.1902 14.19 80.7702 14.45C80.6502 14.53 80.4602 14.59 80.2602 14.59L80.2002 14.17C80.3302 14.15 80.4402 14.09 80.5102 14.02C80.7102 13.82 80.7402 13.37 80.7402 12.92V11.69H82.5602L82.5502 11.68Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6701 11.68V12.71C83.7601 12.7 83.9101 12.69 84.0201 12.69C84.6201 12.69 85.1401 12.97 85.1401 13.6C85.1401 13.87 85.0601 14.07 84.9101 14.22C84.6601 14.49 84.2101 14.57 83.7901 14.57C83.5001 14.57 83.2701 14.55 83.1401 14.53V11.67H83.6601L83.6701 11.68ZM83.6701 14.16C83.7501 14.17 83.8301 14.18 83.9401 14.18C84.3001 14.18 84.6001 14 84.6001 13.63C84.6001 13.26 84.3001 13.1 83.9401 13.1C83.8501 13.1 83.7501 13.1 83.6701 13.12V14.17V14.16Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1201 11.68V12.83H87.3401V11.68H87.8601V14.55H87.3401V13.28H86.1201V14.55H85.6001V11.68H86.1201Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0001 13.09C91.0001 14.05 90.4201 14.6 89.6301 14.6C88.8401 14.6 88.3101 13.98 88.3101 13.14C88.3101 12.3 88.8601 11.64 89.6701 11.64C90.4801 11.64 91.0001 12.27 91.0001 13.09ZM88.8601 13.13C88.8601 13.71 89.1501 14.18 89.6601 14.18C90.1701 14.18 90.4501 13.71 90.4501 13.11C90.4501 12.57 90.1801 12.06 89.6601 12.06C89.1401 12.06 88.8601 12.54 88.8601 13.13Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0902 11.68V12.11H91.9702V14.55H91.4502V11.68H93.0902Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8201 13.09C95.8201 14.05 95.2401 14.6 94.4501 14.6C93.6601 14.6 93.1301 13.98 93.1301 13.14C93.1301 12.3 93.6801 11.64 94.4901 11.64C95.3001 11.64 95.8201 12.27 95.8201 13.09ZM93.6801 13.13C93.6801 13.71 93.9701 14.18 94.4801 14.18C94.9901 14.18 95.2701 13.71 95.2701 13.11C95.2701 12.57 95.0001 12.06 94.4801 12.06C93.9601 12.06 93.6801 12.54 93.6801 13.13Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.04 11.86C97.24 11.74 97.51 11.63 97.87 11.63C98.44 11.63 98.8 11.92 98.8 12.35C98.8 12.71 98.55 12.96 98.22 13.04C98.6 13.09 98.91 13.35 98.91 13.74C98.91 14.36 98.32 14.59 97.79 14.59C97.51 14.59 97.21 14.53 96.98 14.4L97.1 14C97.24 14.08 97.52 14.17 97.77 14.17C98.14 14.17 98.36 13.99 98.36 13.72C98.36 13.35 97.99 13.26 97.68 13.26H97.45V12.87H97.68C98.01 12.87 98.27 12.7 98.27 12.44C98.27 12.2 98.09 12.06 97.8 12.06C97.58 12.06 97.34 12.15 97.18 12.23L97.05 11.85L97.04 11.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48 11.68V14.13H101.75L101.72 15.26H101.32L101.29 14.55H99.5501L99.5201 15.26H99.1201L99.0901 14.15H99.3201C99.4301 13.94 99.5301 13.73 99.6001 13.5C99.6901 13.19 99.7201 12.84 99.7201 12.43V11.68H101.47H101.48ZM100.21 12.56C100.21 12.95 100.17 13.31 100.07 13.61C100.02 13.8 99.9301 13.98 99.8601 14.12H100.95V12.11H100.2V12.56H100.21Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 13.09C104.67 14.05 104.09 14.6 103.29 14.6C102.49 14.6 101.97 13.98 101.97 13.14C101.97 12.3 102.52 11.64 103.33 11.64C104.14 11.64 104.66 12.27 104.66 13.09M102.52 13.13C102.52 13.71 102.81 14.18 103.32 14.18C103.83 14.18 104.11 13.71 104.11 13.11C104.11 12.57 103.84 12.06 103.32 12.06C102.8 12.06 102.52 12.54 102.52 13.13Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 13.09C104.67 14.05 104.09 14.6 103.29 14.6C102.49 14.6 101.97 13.98 101.97 13.14C101.97 12.3 102.52 11.64 103.33 11.64C104.14 11.64 104.66 12.27 104.66 13.09M102.52 13.13C102.52 13.71 102.81 14.18 103.32 14.18C103.83 14.18 104.11 13.71 104.11 13.11C104.11 12.57 103.84 12.06 103.32 12.06C102.8 12.06 102.52 12.54 102.52 13.13Z",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12 11.72C105.31 11.69 105.57 11.66 105.92 11.66C106.3 11.66 106.58 11.74 106.77 11.89C106.94 12.03 107.05 12.26 107.05 12.53C107.05 12.8 106.97 13.03 106.8 13.18C106.59 13.39 106.26 13.49 105.89 13.49C105.79 13.49 105.7 13.49 105.64 13.47V14.55H105.12V11.72ZM105.64 13.06C105.7 13.08 105.79 13.08 105.89 13.08C106.28 13.08 106.52 12.89 106.52 12.55C106.52 12.23 106.3 12.06 105.94 12.06C105.8 12.06 105.69 12.07 105.64 12.08V13.05V13.06Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.02 13.09C110.02 14.05 109.44 14.6 108.64 14.6C107.84 14.6 107.32 13.98 107.32 13.14C107.32 12.3 107.87 11.64 108.68 11.64C109.49 11.64 110.01 12.27 110.01 13.09M107.87 13.13C107.87 13.71 108.16 14.18 108.67 14.18C109.18 14.18 109.46 13.71 109.46 13.11C109.46 12.57 109.19 12.06 108.67 12.06C108.15 12.06 107.87 12.54 107.87 13.13Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.02 13.09C110.02 14.05 109.44 14.6 108.64 14.6C107.84 14.6 107.32 13.98 107.32 13.14C107.32 12.3 107.87 11.64 108.68 11.64C109.49 11.64 110.01 12.27 110.01 13.09M107.87 13.13C107.87 13.71 108.16 14.18 108.67 14.18C109.18 14.18 109.46 13.71 109.46 13.11C109.46 12.57 109.19 12.06 108.67 12.06C108.15 12.06 107.87 12.54 107.87 13.13Z",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.46 11.72C110.63 11.69 110.93 11.66 111.22 11.66C111.61 11.66 111.85 11.71 112.04 11.84C112.22 11.95 112.34 12.13 112.34 12.38C112.34 12.64 112.17 12.89 111.86 13C112.16 13.09 112.44 13.32 112.44 13.72C112.44 13.98 112.33 14.18 112.16 14.31C111.96 14.49 111.62 14.58 111.1 14.58C110.81 14.58 110.59 14.56 110.46 14.54V11.72ZM110.98 12.85H111.25C111.61 12.85 111.82 12.68 111.82 12.44C111.82 12.17 111.62 12.05 111.28 12.05C111.13 12.05 111.04 12.05 110.98 12.07V12.85ZM110.98 14.17C111.05 14.17 111.14 14.18 111.26 14.18C111.6 14.18 111.89 14.05 111.89 13.7C111.89 13.37 111.6 13.23 111.24 13.23H110.98V14.17Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43 11.68V12.71C113.52 12.7 113.67 12.69 113.78 12.69C114.38 12.69 114.9 12.97 114.9 13.6C114.9 13.87 114.82 14.07 114.67 14.22C114.41 14.49 113.97 14.57 113.55 14.57C113.26 14.57 113.04 14.55 112.9 14.53V11.67H113.42L113.43 11.68ZM113.43 14.16C113.51 14.17 113.59 14.18 113.7 14.18C114.06 14.18 114.36 14 114.36 13.63C114.36 13.26 114.06 13.1 113.7 13.1C113.61 13.1 113.51 13.1 113.43 13.12V14.17V14.16Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11 14.55C115.16 14.47 115.2 14.36 115.24 14.26C115.36 13.93 115.43 13.57 115.66 13.34C115.72 13.28 115.81 13.23 115.9 13.19C115.56 13.12 115.28 12.88 115.28 12.48C115.28 12.22 115.39 12.02 115.56 11.88C115.76 11.72 116.08 11.66 116.45 11.66C116.73 11.66 117.01 11.69 117.21 11.72V14.55H116.69V13.37H116.48C116.33 13.37 116.22 13.41 116.13 13.49C115.94 13.68 115.87 14.06 115.77 14.32C115.74 14.4 115.72 14.46 115.67 14.55H115.11ZM116.69 12.09C116.63 12.08 116.53 12.06 116.38 12.06C116.07 12.06 115.8 12.18 115.8 12.52C115.8 12.82 116.07 12.99 116.41 12.99C116.51 12.99 116.62 12.99 116.68 12.99V12.1L116.69 12.09Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8201 17.86V18.87C41.8201 19.33 41.8101 19.75 41.7901 20.13C41.9401 19.81 42.1301 19.47 42.3101 19.14L43.0701 17.85H43.6001V20.72H43.1101V19.7C43.1101 19.25 43.1101 18.88 43.1501 18.51C43.0101 18.84 42.8201 19.2 42.6401 19.5L41.9201 20.71H41.3401V17.84H41.8201V17.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.83 19.91L47.58 20.72H47.04L47.96 17.85H48.63L49.56 20.72H49L48.74 19.91H47.83ZM48.65 19.51L48.42 18.8C48.37 18.63 48.32 18.43 48.28 18.26C48.24 18.43 48.19 18.63 48.14 18.8L47.92 19.51H48.66H48.65Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5601 17.86V19.09H51.6501L52.53 17.86H53.17L52.1301 19.15C52.5501 19.23 52.72 19.5 52.85 19.86C52.96 20.16 53.05 20.45 53.17 20.72H52.6101C52.5101 20.52 52.44 20.29 52.37 20.07C52.26 19.72 52.1 19.47 51.69 19.47H51.57V20.72H51.05V17.85H51.57L51.5601 17.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2201 18.3H54.4001V17.86H56.5701V18.3H55.7401V20.73H55.2201V18.3Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47 17.86V18.87C58.47 19.33 58.46 19.75 58.44 20.13C58.59 19.81 58.78 19.47 58.96 19.14L59.72 17.85H60.25V20.72H59.77V19.7C59.77 19.25 59.77 18.88 59.81 18.51C59.67 18.84 59.48 19.2 59.3 19.5L58.58 20.71H58V17.84H58.48L58.47 17.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9402 17.9C62.1102 17.87 62.4102 17.84 62.7002 17.84C63.0902 17.84 63.3202 17.89 63.5202 18.02C63.7002 18.13 63.8202 18.31 63.8202 18.56C63.8202 18.82 63.6502 19.07 63.3402 19.18C63.6402 19.27 63.9202 19.5 63.9202 19.9C63.9202 20.16 63.8102 20.36 63.6402 20.49C63.4402 20.67 63.1002 20.76 62.5802 20.76C62.2902 20.76 62.0702 20.74 61.9402 20.72V17.9ZM62.4602 19.03H62.7302C63.0902 19.03 63.3002 18.86 63.3002 18.62C63.3002 18.35 63.1002 18.23 62.7602 18.23C62.6102 18.23 62.5202 18.23 62.4602 18.25V19.03ZM62.4602 20.35C62.5302 20.35 62.6202 20.36 62.7402 20.36C63.0802 20.36 63.3802 20.23 63.3802 19.88C63.3802 19.55 63.0902 19.41 62.7302 19.41H62.4702V20.35H62.4602Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.99 17.86V19.01H67.21V17.86H67.73V20.73H67.21V19.46H65.99V20.73H65.47V17.86H65.99Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.96 19.26C71.96 20.22 71.38 20.77 70.58 20.77C69.78 20.77 69.26 20.15 69.26 19.31C69.26 18.47 69.81 17.81 70.62 17.81C71.43 17.81 71.95 18.44 71.95 19.26M69.81 19.3C69.81 19.88 70.1 20.35 70.61 20.35C71.12 20.35 71.4 19.88 71.4 19.28C71.4 18.74 71.13 18.23 70.61 18.23C70.09 18.23 69.81 18.71 69.81 19.3Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.96 19.26C71.96 20.22 71.38 20.77 70.58 20.77C69.78 20.77 69.26 20.15 69.26 19.31C69.26 18.47 69.81 17.81 70.62 17.81C71.43 17.81 71.95 18.44 71.95 19.26M69.81 19.3C69.81 19.88 70.1 20.35 70.61 20.35C71.12 20.35 71.4 19.88 71.4 19.28C71.4 18.74 71.13 18.23 70.61 18.23C70.09 18.23 69.81 18.71 69.81 19.3Z",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.13 17.86V18.29H74.01V20.73H73.49V17.86H75.13Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.94 19.26C78.94 20.22 78.36 20.77 77.57 20.77C76.78 20.77 76.25 20.15 76.25 19.31C76.25 18.47 76.8 17.81 77.61 17.81C78.42 17.81 78.94 18.44 78.94 19.26ZM76.8 19.3C76.8 19.88 77.09 20.35 77.6 20.35C78.11 20.35 78.39 19.88 78.39 19.28C78.39 18.74 78.12 18.23 77.6 18.23C77.08 18.23 76.8 18.71 76.8 19.3Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5702 17.86V20.31H84.8402L84.8102 21.44H84.4102L84.3802 20.73H82.6402L82.6102 21.44H82.2102L82.1802 20.32H82.4102C82.5202 20.11 82.6202 19.9 82.6902 19.67C82.7802 19.36 82.8102 19.01 82.8102 18.6V17.85H84.5602L84.5702 17.86ZM83.3002 18.74C83.3002 19.13 83.2602 19.49 83.1602 19.79C83.1102 19.98 83.0202 20.16 82.9502 20.3H84.0402V18.29H83.2902V18.74H83.3002Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8502 19.26C88.8502 20.22 88.2702 20.77 87.4802 20.77C86.6902 20.77 86.1602 20.15 86.1602 19.31C86.1602 18.47 86.7101 17.81 87.5201 17.81C88.3301 17.81 88.8502 18.44 88.8502 19.26ZM86.7102 19.3C86.7102 19.88 87.0002 20.35 87.5102 20.35C88.0202 20.35 88.3002 19.88 88.3002 19.28C88.3002 18.74 88.0302 18.23 87.5102 18.23C86.9902 18.23 86.7102 18.71 86.7102 19.3Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.38 17.86V20.73H91.86V18.29H91.08V19.06C91.08 19.75 91.02 20.37 90.6 20.63C90.48 20.71 90.29 20.77 90.09 20.77L90.03 20.35C90.16 20.33 90.27 20.27 90.35 20.2C90.55 20 90.58 19.55 90.58 19.1V17.87H92.4L92.38 17.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7001 17.86V18.29H94.5901V20.73H94.0701V17.86H95.7001Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5201 19.26C99.5201 20.22 98.9401 20.77 98.1501 20.77C97.3601 20.77 96.8301 20.15 96.8301 19.31C96.8301 18.47 97.3801 17.81 98.1901 17.81C99.0001 17.81 99.5201 18.44 99.5201 19.26ZM97.3801 19.3C97.3801 19.88 97.6701 20.35 98.1801 20.35C98.6901 20.35 98.9701 19.88 98.9701 19.28C98.9701 18.74 98.7001 18.23 98.1801 18.23C97.6601 18.23 97.3801 18.71 97.3801 19.3Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.06 17.86V20.73H102.54V18.29H101.76V19.06C101.76 19.75 101.7 20.37 101.28 20.63C101.16 20.71 100.97 20.77 100.77 20.77L100.71 20.35C100.84 20.33 100.95 20.27 101.02 20.2C101.22 20 101.25 19.55 101.25 19.1V17.87H103.07L103.06 17.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.35 19.46H105.27V20.3H106.48V20.73H104.74V17.86H106.41V18.29H105.27V19.03H106.35V19.46Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56 18.3H107.75V17.86H109.91V18.3H109.09V20.73H108.56V18.3Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82 17.86V18.87C111.82 19.33 111.81 19.75 111.79 20.13C111.94 19.81 112.13 19.47 112.31 19.14L113.07 17.85H113.6V20.72H113.11V19.7C113.11 19.25 113.11 18.88 113.15 18.51C113.01 18.84 112.82 19.2 112.64 19.5L111.92 20.71H111.34V17.84H111.83L111.82 17.86Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.03 20.73C115.08 20.65 115.12 20.54 115.16 20.44C115.28 20.11 115.35 19.75 115.58 19.52C115.64 19.46 115.73 19.41 115.82 19.38C115.48 19.31 115.2 19.07 115.2 18.67C115.2 18.41 115.31 18.21 115.48 18.07C115.68 17.91 116 17.85 116.37 17.85C116.65 17.85 116.93 17.88 117.13 17.91V20.74H116.61V19.56H116.4C116.25 19.56 116.14 19.6 116.05 19.68C115.86 19.87 115.79 20.25 115.69 20.51C115.66 20.59 115.64 20.65 115.59 20.74H115.03V20.73ZM116.61 18.27C116.55 18.26 116.45 18.24 116.3 18.24C115.99 18.24 115.72 18.36 115.72 18.7C115.72 19 115.99 19.17 116.33 19.17C116.43 19.17 116.54 19.17 116.6 19.17V18.28L116.61 18.27Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8501 35.87V37.1H41.9401L42.8201 35.87H43.4601L42.4201 37.16C42.8401 37.24 43.0101 37.51 43.1401 37.87C43.2501 38.17 43.3401 38.46 43.4601 38.73H42.9001C42.8001 38.53 42.7301 38.3 42.6601 38.08C42.5501 37.73 42.3901 37.48 41.9801 37.48H41.8601V38.73H41.3401V35.86H41.8601L41.8501 35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21 37.28C47.21 38.24 46.63 38.79 45.83 38.79C45.03 38.79 44.51 38.17 44.51 37.33C44.51 36.49 45.06 35.83 45.87 35.83C46.68 35.83 47.2 36.46 47.2 37.28M45.06 37.32C45.06 37.9 45.35 38.37 45.86 38.37C46.37 38.37 46.65 37.9 46.65 37.3C46.65 36.76 46.38 36.25 45.86 36.25C45.34 36.25 45.06 36.73 45.06 37.32Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21 37.28C47.21 38.24 46.63 38.79 45.83 38.79C45.03 38.79 44.51 38.17 44.51 37.33C44.51 36.49 45.06 35.83 45.87 35.83C46.68 35.83 47.2 36.46 47.2 37.28M45.06 37.32C45.06 37.9 45.35 38.37 45.86 38.37C46.37 38.37 46.65 37.9 46.65 37.3C46.65 36.76 46.38 36.25 45.86 36.25C45.34 36.25 45.06 36.73 45.06 37.32Z",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1301 35.87V37.02H50.3401V35.87H50.8701V38.74H50.3401V37.48H49.1301V38.74H48.6101V35.87H49.1301Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9402 35.87V38.31H54.0802V35.87H54.6102V38.32L54.8802 38.34L54.8502 39.45H54.4402L54.4202 38.74H52.4202V35.87H52.9402Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.84 37.47H56.76V38.31H57.97V38.74H56.24V35.87H57.9V36.3H56.76V37.04H57.84V37.47Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5801 35.87V38.74H61.0601V36.3H59.9001V38.74H59.3801V35.87H61.5801Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6801 36.31H62.8701V35.87H65.0301V36.31H64.2101V38.74H63.6801V36.31Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7602 35.87L67.2402 36.98C67.3202 37.17 67.3802 37.34 67.4402 37.51H67.4501C67.4901 37.38 67.5402 37.19 67.6102 36.97L67.9902 35.88H68.5402L67.9702 37.31C67.8002 37.73 67.6202 38.16 67.4202 38.43C67.2302 38.66 67.0102 38.8 66.7102 38.8C66.5902 38.8 66.5102 38.79 66.4402 38.76L66.4802 38.34C66.4802 38.34 66.5802 38.36 66.6602 38.36C66.9002 38.36 67.0601 38.16 67.1301 37.99C67.1501 37.93 67.1502 37.89 67.1202 37.84L66.1602 35.89H66.7502L66.7602 35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1101 37.93L69.8601 38.74H69.3201L70.2401 35.87H70.9101L71.8401 38.74H71.2801L71.0201 37.93H70.1101ZM70.9301 37.53L70.7001 36.82C70.6501 36.65 70.6001 36.45 70.5601 36.28C70.5201 36.45 70.4701 36.65 70.4201 36.82L70.2001 37.53H70.9401H70.9301Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33 35.87V38.74H74.81V36.3H74.03V37.07C74.03 37.76 73.97 38.38 73.55 38.64C73.43 38.72 73.24 38.78 73.04 38.78L72.98 38.36C73.11 38.34 73.22 38.28 73.29 38.21C73.49 38.01 73.52 37.56 73.52 37.11V35.88H75.34L75.33 35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4001 35.87V36.9C77.4901 36.89 77.6401 36.88 77.7501 36.88C78.3501 36.88 78.8701 37.16 78.8701 37.79C78.8701 38.06 78.7901 38.26 78.6401 38.41C78.3901 38.68 77.9401 38.76 77.5201 38.76C77.2301 38.76 77.0001 38.74 76.8701 38.72V35.86H77.3901L77.4001 35.87ZM77.4001 38.35C77.4801 38.36 77.5601 38.37 77.6701 38.37C78.0301 38.37 78.3301 38.19 78.3301 37.82C78.3301 37.45 78.0301 37.29 77.6701 37.29C77.5801 37.29 77.4801 37.29 77.4001 37.31V38.36V38.35Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.81 35.87V37.02H82.02V35.87H82.55V38.74H82.02V37.48H80.81V38.74H80.29V35.87H80.81Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6701 37.93L84.4201 38.74H83.8801L84.8001 35.87H85.4701L86.4001 38.74H85.8401L85.5801 37.93H84.6701ZM85.4901 37.53L85.2601 36.82C85.2001 36.65 85.1601 36.45 85.1201 36.28C85.0801 36.45 85.0401 36.65 84.9801 36.82L84.7601 37.53H85.5001H85.4901Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49 38.74C87.54 38.65 87.58 38.55 87.62 38.45C87.74 38.12 87.81 37.76 88.04 37.53C88.1 37.47 88.19 37.42 88.28 37.38C87.94 37.31 87.66 37.07 87.66 36.67C87.66 36.41 87.77 36.21 87.94 36.07C88.14 35.91 88.46 35.85 88.82 35.85C89.1 35.85 89.38 35.88 89.58 35.91V38.74H89.06V37.56H88.85C88.7 37.56 88.59 37.6 88.5 37.68C88.31 37.87 88.23 38.25 88.14 38.51C88.11 38.59 88.09 38.65 88.04 38.74H87.48H87.49ZM89.07 36.28C89.01 36.27 88.91 36.25 88.76 36.25C88.45 36.25 88.18 36.37 88.18 36.71C88.18 37.01 88.45 37.18 88.79 37.18C88.89 37.18 88.99 37.18 89.06 37.18V36.29L89.07 36.28Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.49 35.87V37.1H93.57L94.45 35.87H95.09L94.05 37.16C94.47 37.24 94.64 37.51 94.77 37.87C94.88 38.17 94.97 38.46 95.09 38.73H94.53C94.43 38.53 94.36 38.3 94.29 38.08C94.18 37.73 94.02 37.48 93.61 37.48H93.49V38.73H92.97V35.86H93.49V35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5502 35.87V38.74H98.0302V36.3H97.2502V37.07C97.2502 37.76 97.1902 38.38 96.7702 38.64C96.6502 38.72 96.4602 38.78 96.2602 38.78L96.2002 38.36C96.3302 38.34 96.4402 38.28 96.5202 38.21C96.7202 38.01 96.7502 37.56 96.7502 37.11V35.88H98.5702L98.5502 35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59 35.87V36.88C100.59 37.34 100.58 37.76 100.56 38.14C100.71 37.82 100.9 37.48 101.08 37.15L101.84 35.86H102.37V38.73H101.89V37.71C101.89 37.26 101.89 36.89 101.93 36.52C101.79 36.85 101.6 37.21 101.42 37.51L100.7 38.72H100.12V35.85H100.6L100.59 35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44 35.87V37.02H105.66V35.87H106.18V38.74H105.66V37.48H104.44V38.74H103.92V35.87H104.44Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21 35.87V36.88C108.21 37.34 108.2 37.76 108.18 38.14C108.33 37.82 108.52 37.48 108.7 37.15L109.46 35.86H109.99V38.73H109.51V37.71C109.51 37.26 109.51 36.89 109.55 36.52C109.41 36.85 109.22 37.21 109.04 37.51L108.32 38.72H107.74V35.85H108.22L108.21 35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.07 35.87V37.1H112.15L113.03 35.87H113.67L112.63 37.16C113.05 37.24 113.22 37.51 113.35 37.87C113.46 38.17 113.55 38.46 113.67 38.73H113.11C113.01 38.53 112.94 38.3 112.87 38.08C112.76 37.73 112.6 37.48 112.19 37.48H112.07V38.73H111.55V35.86H112.07V35.87Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.57 37.93L115.32 38.74H114.78L115.7 35.87H116.37L117.3 38.74H116.74L116.48 37.93H115.57ZM116.39 37.53L116.16 36.82C116.11 36.65 116.06 36.45 116.02 36.28C115.98 36.45 115.94 36.65 115.88 36.82L115.66 37.53H116.4H116.39Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4999 43.26H42.7799C42.7399 42.8 42.4399 42.43 41.8999 42.43C41.6699 42.43 41.4699 42.49 41.2999 42.56L41.1899 42.17C41.3799 42.08 41.6499 42 41.9399 42C42.8999 42 43.3399 42.67 43.3399 43.48C43.3399 44.43 42.6999 44.96 41.8899 44.96C41.5999 44.96 41.3199 44.9 41.1399 44.82L41.2399 44.41C41.3999 44.48 41.6299 44.53 41.8399 44.53C42.3899 44.53 42.7299 44.16 42.7699 43.66H41.4899V43.25L41.4999 43.26Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2099 42.05V43.28H46.2899L47.1699 42.05H47.8099L46.7699 43.34C47.1899 43.42 47.3599 43.69 47.4899 44.05C47.5999 44.35 47.6899 44.64 47.8099 44.91H47.2499C47.1499 44.71 47.0799 44.48 47.0099 44.26C46.8999 43.91 46.7399 43.66 46.3299 43.66H46.2099V44.91H45.6899V42.04H46.2099V42.05Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0298 44.84C51.9098 44.9 51.6298 44.97 51.2898 44.97C50.3798 44.97 49.8298 44.4 49.8298 43.53C49.8298 42.58 50.4898 42.01 51.3598 42.01C51.6998 42.01 51.9498 42.08 52.0598 42.14L51.9498 42.56C51.8098 42.5 51.6298 42.45 51.3898 42.45C50.8098 42.45 50.3898 42.82 50.3898 43.51C50.3898 44.14 50.7598 44.54 51.3898 44.54C51.5998 44.54 51.8198 44.5 51.9598 44.43L52.0498 44.84H52.0298Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5799 42.05V44.92H56.0599V42.48H54.8999V44.92H54.3799V42.05H56.5799Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6898 43.65H59.6098V44.49H60.8198V44.92H59.0898V42.05H60.7598V42.48H59.6098V43.22H60.6898V43.65Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1799 42.09C63.3699 42.06 63.6299 42.03 63.9799 42.03C64.3599 42.03 64.6399 42.11 64.8299 42.26C64.9999 42.4 65.1099 42.63 65.1099 42.89C65.1099 43.15 65.0199 43.39 64.8599 43.54C64.6499 43.75 64.3199 43.85 63.9499 43.85C63.8499 43.85 63.7599 43.85 63.6999 43.83V44.91H63.1799V42.08V42.09ZM63.6999 43.43C63.7599 43.45 63.8499 43.45 63.9499 43.45C64.3399 43.45 64.5799 43.26 64.5799 42.92C64.5799 42.6 64.3599 42.43 63.9999 42.43C63.8499 42.43 63.7499 42.44 63.6999 42.45V43.42V43.43Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.03 42.49H67.22V42.05H69.38V42.49H68.56V44.92H68.03V42.49Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1399 42.05V43.2H73.3599V42.05H73.8799V44.92H73.3599V43.66H72.1399V44.92H71.6199V42.05H72.1399Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93 43.46C78.93 44.42 78.35 44.97 77.56 44.97C76.77 44.97 76.24 44.35 76.24 43.51C76.24 42.67 76.79 42.01 77.6 42.01C78.41 42.01 78.93 42.64 78.93 43.46ZM76.79 43.5C76.79 44.08 77.08 44.55 77.59 44.55C78.1 44.55 78.38 44.08 78.38 43.48C78.38 42.94 78.11 42.43 77.59 42.43C77.07 42.43 76.79 42.91 76.79 43.5Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9198 42.05V42.48H81.7998V44.92H81.2798V42.05H82.9198Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5599 43.46C87.5599 44.42 86.9799 44.97 86.1899 44.97C85.3999 44.97 84.8699 44.35 84.8699 43.51C84.8699 42.67 85.4199 42.01 86.2299 42.01C87.0399 42.01 87.5599 42.64 87.5599 43.46ZM85.4199 43.5C85.4199 44.08 85.7099 44.55 86.2199 44.55C86.7299 44.55 87.0099 44.08 87.0099 43.48C87.0099 42.94 86.7399 42.43 86.2199 42.43C85.6999 42.43 85.4199 42.91 85.4199 43.5Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9899 42.05L93.4699 43.16C93.5499 43.35 93.6099 43.52 93.6799 43.69H93.6899C93.7299 43.56 93.7799 43.37 93.8499 43.15L94.2199 42.06H94.7699L94.1999 43.49C94.0299 43.91 93.8499 44.34 93.6499 44.61C93.4599 44.84 93.2399 44.98 92.9399 44.98C92.8199 44.98 92.7399 44.97 92.6699 44.94L92.7099 44.52C92.7099 44.52 92.8099 44.54 92.8899 44.54C93.1299 44.54 93.2899 44.34 93.3599 44.17C93.3799 44.11 93.3799 44.07 93.3499 44.02L92.3899 42.07H92.9799L92.9899 42.05Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.96 42.09C97.15 42.06 97.41 42.03 97.76 42.03C98.14 42.03 98.42 42.11 98.61 42.26C98.78 42.4 98.89 42.63 98.89 42.89C98.89 43.15 98.8 43.39 98.64 43.54C98.43 43.75 98.1 43.85 97.73 43.85C97.63 43.85 97.54 43.85 97.48 43.83V44.91H96.96V42.08V42.09ZM97.48 43.43C97.54 43.45 97.63 43.45 97.73 43.45C98.12 43.45 98.36 43.26 98.36 42.92C98.36 42.6 98.14 42.43 97.78 42.43C97.63 42.43 97.53 42.44 97.48 42.45V43.42V43.43Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77 43.46C103.77 44.42 103.19 44.97 102.4 44.97C101.61 44.97 101.08 44.35 101.08 43.51C101.08 42.67 101.63 42.01 102.44 42.01C103.25 42.01 103.77 42.64 103.77 43.46ZM101.63 43.5C101.63 44.08 101.92 44.55 102.43 44.55C102.94 44.55 103.22 44.08 103.22 43.48C103.22 42.94 102.95 42.43 102.43 42.43C101.91 42.43 101.63 42.91 101.63 43.5Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12 42.09C106.29 42.06 106.59 42.03 106.88 42.03C107.27 42.03 107.5 42.08 107.7 42.21C107.88 42.32 108 42.5 108 42.75C108 43.01 107.83 43.26 107.52 43.37C107.82 43.46 108.1 43.69 108.1 44.09C108.1 44.34 107.99 44.55 107.82 44.68C107.62 44.86 107.28 44.95 106.76 44.95C106.47 44.95 106.25 44.93 106.12 44.91V42.09ZM106.64 43.22H106.91C107.27 43.22 107.48 43.05 107.48 42.81C107.48 42.54 107.28 42.42 106.94 42.42C106.79 42.42 106.7 42.42 106.64 42.44V43.22ZM106.64 44.54C106.71 44.54 106.8 44.55 106.92 44.55C107.26 44.55 107.56 44.42 107.56 44.07C107.56 43.74 107.27 43.6 106.91 43.6H106.65V44.54H106.64Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.99 42.05V43.2H112.21V42.05H112.73V44.92H112.21V43.66H110.99V44.92H110.47V42.05H110.99Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.98 44.92C115.03 44.83 115.07 44.73 115.11 44.63C115.23 44.3 115.3 43.94 115.53 43.71C115.59 43.65 115.68 43.6 115.77 43.57C115.43 43.5 115.15 43.26 115.15 42.86C115.15 42.6 115.26 42.4 115.43 42.26C115.63 42.1 115.95 42.04 116.32 42.04C116.6 42.04 116.88 42.07 117.08 42.1V44.93H116.56V43.75H116.35C116.2 43.75 116.09 43.79 116 43.87C115.81 44.06 115.74 44.44 115.64 44.7C115.61 44.78 115.59 44.84 115.54 44.93H114.98V44.92ZM116.56 42.46C116.5 42.45 116.4 42.43 116.25 42.43C115.94 42.43 115.67 42.55 115.67 42.89C115.67 43.19 115.94 43.36 116.28 43.36C116.38 43.36 116.49 43.36 116.55 43.36V42.47L116.56 42.46Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8501 24.11V25.34H41.9401L42.8201 24.11H43.4601L42.4201 25.4C42.8401 25.48 43.0101 25.75 43.1401 26.11C43.2501 26.41 43.3401 26.7 43.4601 26.97H42.9001C42.8001 26.77 42.7301 26.54 42.6601 26.32C42.5501 25.97 42.3901 25.72 41.9801 25.72H41.8601V26.97H41.3401V24.1H41.8601L41.8501 24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6801 24.11V26.98H46.1601V24.54H45.3801V25.31C45.3801 26 45.3201 26.62 44.9001 26.88C44.7801 26.96 44.5901 27.02 44.3901 27.02L44.3301 26.6C44.4601 26.58 44.5701 26.52 44.6501 26.45C44.8501 26.25 44.8801 25.8 44.8801 25.35V24.12H46.7001L46.6801 24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.49 24.11V25.12C48.49 25.58 48.48 26 48.46 26.38C48.61 26.06 48.8 25.72 48.98 25.39L49.74 24.1H50.27V26.97H49.78V25.95C49.78 25.5 49.78 25.13 49.82 24.76C49.68 25.09 49.49 25.45 49.31 25.75L48.59 26.96H48.01V24.09H48.49V24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1201 24.11V25.25H53.3301V24.11H53.8501V26.98H53.3301V25.71H52.1201V26.98H51.5901V24.11H52.1201Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6602 24.11V25.12C55.6602 25.58 55.6502 26 55.6302 26.38C55.7802 26.06 55.9702 25.72 56.1502 25.39L56.9102 24.1H57.4402V26.97H56.9502V25.95C56.9502 25.5 56.9502 25.13 56.9902 24.76C56.8502 25.09 56.6602 25.45 56.4802 25.75L55.7602 26.96H55.1802V24.09H55.6602V24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24 24.11V24.97C59.24 25.33 59.43 25.51 59.78 25.51C59.95 25.51 60.13 25.45 60.26 25.38V24.1H60.78V26.97H60.26V25.77H60.25C60.05 25.88 59.83 25.93 59.59 25.93C59.13 25.93 58.72 25.7 58.72 25.05V24.1H59.24V24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7101 25.7H62.6301V26.55H63.8401V26.98H62.1001V24.11H63.7701V24.54H62.6301V25.28H63.7101V25.7Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0701 26.89C66.9501 26.95 66.6701 27.02 66.3301 27.02C65.4201 27.02 64.8701 26.45 64.8701 25.58C64.8701 24.63 65.5301 24.06 66.4001 24.06C66.7401 24.06 66.9901 24.13 67.1001 24.19L66.9901 24.61C66.8501 24.55 66.6701 24.5 66.4301 24.5C65.8501 24.5 65.4201 24.87 65.4201 25.56C65.4201 26.19 65.7901 26.59 66.4201 26.59C66.6301 26.59 66.8601 26.55 66.9901 26.48L67.0801 26.89H67.0701Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75 24.11V25.34H68.84L69.72 24.11H70.36L69.32 25.4C69.74 25.48 69.91 25.75 70.04 26.11C70.15 26.41 70.24 26.7 70.36 26.97H69.8C69.7 26.77 69.63 26.54 69.56 26.32C69.45 25.97 69.29 25.72 68.88 25.72H68.76V26.97H68.24V24.1H68.76L68.75 24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.02 26.16L71.77 26.97H71.23L72.15 24.1H72.82L73.75 26.97H73.19L72.93 26.16H72.02ZM72.84 25.76L72.61 25.05C72.55 24.88 72.51 24.68 72.47 24.51C72.43 24.68 72.38 24.88 72.33 25.05L72.11 25.76H72.85H72.84Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6201 26.98C74.6701 26.89 74.7101 26.79 74.7501 26.69C74.8701 26.36 74.9401 26 75.1701 25.77C75.2301 25.71 75.3201 25.66 75.4101 25.62C75.0701 25.55 74.7901 25.31 74.7901 24.91C74.7901 24.65 74.9001 24.45 75.0701 24.31C75.2701 24.15 75.5901 24.09 75.9501 24.09C76.2301 24.09 76.5101 24.12 76.7101 24.15V26.98H76.1901V25.8H75.9801C75.8301 25.8 75.7201 25.84 75.6301 25.92C75.4401 26.11 75.3601 26.49 75.2701 26.75C75.2401 26.83 75.2201 26.89 75.1701 26.98H74.6101H74.6201ZM76.2001 24.52C76.1401 24.51 76.0401 24.49 75.8901 24.49C75.5801 24.49 75.3101 24.61 75.3101 24.95C75.3101 25.25 75.5801 25.42 75.9201 25.42C76.0201 25.42 76.1201 25.42 76.1901 25.42V24.53L76.2001 24.52Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4101 24.11V24.54H80.1601V25.16C80.2601 25.15 80.4101 25.14 80.5101 25.14C80.7901 25.14 81.0801 25.21 81.2801 25.36C81.4901 25.5 81.6301 25.73 81.6301 26.05C81.6301 26.32 81.5301 26.53 81.3801 26.68C81.1201 26.92 80.7001 27.01 80.2801 27.01C79.9901 27.01 79.7701 26.99 79.6401 26.97V24.11H81.4101ZM80.1601 26.59C80.2401 26.6 80.3301 26.61 80.4401 26.61C80.6301 26.61 80.8201 26.55 80.9401 26.43C81.0301 26.34 81.0901 26.21 81.0901 26.05C81.0901 25.87 81.0201 25.74 80.9001 25.66C80.7701 25.56 80.6001 25.52 80.4201 25.52C80.3401 25.52 80.2501 25.52 80.1601 25.54V26.58V26.59Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3601 26.16L83.1101 26.97H82.5701L83.4901 24.1H84.1601L85.0901 26.97H84.5301L84.2701 26.16H83.3601ZM84.1801 25.76L83.9501 25.05C83.9001 24.88 83.8501 24.68 83.8001 24.51C83.7601 24.68 83.7201 24.88 83.6601 25.05L83.4401 25.76H84.1801Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1301 24.28C86.3301 24.16 86.6001 24.05 86.9601 24.05C87.5301 24.05 87.8901 24.34 87.8901 24.77C87.8901 25.13 87.6401 25.38 87.3101 25.46C87.6901 25.51 88.0001 25.77 88.0001 26.16C88.0001 26.78 87.4101 27.01 86.8801 27.01C86.6001 27.01 86.3001 26.95 86.0701 26.82L86.1901 26.42C86.3301 26.5 86.6101 26.59 86.8601 26.59C87.2301 26.59 87.4501 26.41 87.4501 26.14C87.4501 25.77 87.0801 25.68 86.7701 25.68H86.5401V25.29H86.7701C87.1001 25.29 87.3601 25.12 87.3601 24.86C87.3601 24.62 87.1801 24.48 86.8901 24.48C86.6701 24.48 86.4301 24.57 86.2701 24.65L86.1401 24.27L86.1301 24.28Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7502 26.16L89.5002 26.97H88.9602L89.8802 24.1H90.5502L91.4802 26.97H90.9202L90.6602 26.16H89.7502ZM90.5702 25.76L90.3402 25.05C90.2902 24.88 90.2402 24.68 90.1902 24.51C90.1502 24.68 90.1102 24.88 90.0502 25.05L89.8302 25.76H90.5702Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7202 24.11V25.34H94.8002L95.6802 24.11H96.3202L95.2802 25.4C95.7002 25.48 95.8702 25.75 96.0002 26.11C96.1102 26.41 96.2002 26.7 96.3202 26.97H95.7602C95.6602 26.77 95.5902 26.54 95.5202 26.32C95.4102 25.97 95.2502 25.72 94.8402 25.72H94.7202V26.97H94.2002V24.1H94.7202V24.11Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9902 26.16L97.7402 26.97H97.2002L98.1202 24.1H98.7902L99.7202 26.97H99.1602L98.9002 26.16H97.9902ZM98.8102 25.76L98.5802 25.05C98.5302 24.88 98.4802 24.68 98.4402 24.51C98.4002 24.68 98.3602 24.88 98.3002 25.05L98.0802 25.76H98.8202H98.8102Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.31 23.99V24.25C102.92 24.29 103.53 24.65 103.53 25.54C103.53 26.43 102.93 26.78 102.3 26.84V27.1H101.81V26.84C101.2 26.8 100.6 26.46 100.6 25.56C100.6 24.66 101.27 24.29 101.82 24.25V23.99H102.31ZM101.81 24.61C101.5 24.64 101.12 24.88 101.12 25.55C101.12 26.17 101.48 26.43 101.81 26.47V24.61ZM102.3 26.47C102.62 26.44 102.99 26.2 102.99 25.55C102.99 24.9 102.64 24.65 102.3 24.62V26.48V26.47Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 25.7H105.22V26.55H106.43V26.98H104.7V24.11H106.37V24.54H105.22V25.28H106.3V25.7Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.81 24.11V26.56H110.08L110.05 27.69H109.65L109.62 26.98H107.88L107.85 27.69H107.45L107.42 26.58H107.65C107.76 26.37 107.86 26.16 107.93 25.93C108.02 25.62 108.05 25.27 108.05 24.86V24.11H109.8H109.81ZM108.54 24.99C108.54 25.38 108.5 25.74 108.4 26.04C108.35 26.23 108.26 26.41 108.19 26.55H109.28V24.54H108.53V24.99H108.54Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21 24.14C111.4 24.11 111.66 24.08 112.01 24.08C112.39 24.08 112.67 24.16 112.86 24.31C113.03 24.45 113.14 24.68 113.14 24.94C113.14 25.2 113.05 25.44 112.89 25.59C112.68 25.8 112.35 25.9 111.98 25.9C111.88 25.9 111.79 25.9 111.72 25.88V26.96H111.2V24.13L111.21 24.14ZM111.73 25.48C111.79 25.5 111.88 25.5 111.99 25.5C112.38 25.5 112.62 25.31 112.62 24.97C112.62 24.65 112.4 24.48 112.04 24.48C111.9 24.48 111.79 24.49 111.74 24.5V25.47L111.73 25.48Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83 24.11V25.14C114.92 25.12 115.06 25.11 115.16 25.11C115.75 25.11 116.28 25.39 116.28 26.03C116.28 26.29 116.2 26.49 116.05 26.64C115.79 26.9 115.35 26.99 114.94 26.99C114.65 26.99 114.43 26.97 114.3 26.95V24.09H114.82L114.83 24.11ZM114.83 26.59C114.89 26.6 114.98 26.61 115.09 26.61C115.43 26.61 115.74 26.43 115.74 26.06C115.74 25.69 115.4 25.53 115.09 25.53C114.98 25.53 114.89 25.53 114.83 25.55V26.6V26.59ZM117.1 26.98H116.58V24.11H117.1V26.98Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4999 31.49H42.7799C42.7399 31.03 42.4399 30.66 41.8999 30.66C41.6699 30.66 41.4699 30.72 41.2999 30.79L41.1899 30.4C41.3799 30.31 41.6499 30.23 41.9399 30.23C42.8999 30.23 43.3399 30.9 43.3399 31.71C43.3399 32.66 42.6999 33.19 41.8899 33.19C41.5999 33.19 41.3199 33.13 41.1399 33.05L41.2399 32.64C41.3999 32.71 41.6299 32.76 41.8399 32.76C42.3899 32.76 42.7299 32.39 42.7699 31.89H41.4899V31.48L41.4999 31.49Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8398 30.29V31.43H47.0498V30.29H47.5798V33.15H47.0498V31.89H45.8398V33.15H45.3198V30.29H45.8398Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8299 30.29V32.74H52.0999L52.0699 33.87H51.6699L51.6399 33.16H49.8999L49.8699 33.87H49.4699L49.4399 32.75H49.6699C49.7799 32.54 49.8799 32.33 49.9499 32.1C50.0399 31.79 50.0699 31.44 50.0699 31.03V30.28H51.8199L51.8299 30.29ZM50.5599 31.17C50.5599 31.56 50.5199 31.92 50.4199 32.22C50.3699 32.41 50.2799 32.59 50.2099 32.73H51.2999V30.72H50.5499V31.17H50.5599Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5499 31.69C56.5499 32.65 55.9699 33.2 55.1699 33.2C54.3699 33.2 53.8499 32.58 53.8499 31.74C53.8499 30.9 54.3999 30.24 55.2099 30.24C56.0199 30.24 56.5399 30.87 56.5399 31.69M54.3999 31.73C54.3999 32.31 54.6899 32.78 55.1999 32.78C55.7099 32.78 55.9899 32.31 55.9899 31.71C55.9899 31.17 55.7199 30.66 55.1999 30.66C54.6799 30.66 54.3999 31.14 54.3999 31.73Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5499 31.69C56.5499 32.65 55.9699 33.2 55.1699 33.2C54.3699 33.2 53.8499 32.58 53.8499 31.74C53.8499 30.9 54.3999 30.24 55.2099 30.24C56.0199 30.24 56.5399 30.87 56.5399 31.69M54.3999 31.73C54.3999 32.31 54.6899 32.78 55.1999 32.78C55.7099 32.78 55.9899 32.31 55.9899 31.71C55.9899 31.17 55.7199 30.66 55.1999 30.66C54.6799 30.66 54.3999 31.14 54.3999 31.73Z",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0398 30.29V31.52H59.1298L60.0098 30.29H60.6498L59.6098 31.58C60.0298 31.66 60.1998 31.93 60.3298 32.29C60.4398 32.59 60.5298 32.88 60.6498 33.15H60.0898C59.9898 32.95 59.9198 32.72 59.8498 32.5C59.7398 32.15 59.5798 31.9 59.1698 31.9H59.0498V33.15H58.5298V30.28H59.0498L59.0398 30.29Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 30.32C62.69 30.29 62.95 30.26 63.3 30.26C63.68 30.26 63.96 30.34 64.15 30.49C64.32 30.63 64.43 30.86 64.43 31.13C64.43 31.4 64.35 31.63 64.18 31.78C63.97 31.99 63.64 32.09 63.27 32.09C63.17 32.09 63.08 32.09 63.02 32.07V33.15H62.5V30.32ZM63.02 31.66C63.08 31.68 63.17 31.68 63.27 31.68C63.66 31.68 63.9 31.49 63.9 31.15C63.9 30.83 63.68 30.66 63.32 30.66C63.17 30.66 63.07 30.67 63.02 30.68V31.65V31.66Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8899 30.29V31.3C66.8899 31.76 66.8799 32.18 66.8599 32.56C67.0099 32.24 67.1999 31.9 67.3799 31.57L68.1399 30.28H68.6699V33.15H68.1899V32.13C68.1899 31.68 68.1899 31.31 68.2299 30.94C68.0899 31.27 67.8999 31.63 67.7199 31.93L66.9999 33.14H66.4199V30.27H66.8999L66.8899 30.29Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3198 30.29V31.43H72.5298V30.29H73.0598V33.15H72.5298V31.89H71.3198V33.15H70.7998V30.29H71.3198Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7198 31.69C77.7198 32.65 77.1398 33.2 76.3398 33.2C75.5398 33.2 75.0198 32.58 75.0198 31.74C75.0198 30.9 75.5698 30.24 76.3798 30.24C77.1898 30.24 77.7098 30.87 77.7098 31.69M75.5698 31.73C75.5698 32.31 75.8598 32.78 76.3698 32.78C76.8798 32.78 77.1598 32.31 77.1598 31.71C77.1598 31.17 76.8898 30.66 76.3698 30.66C75.8498 30.66 75.5698 31.14 75.5698 31.73Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7198 31.69C77.7198 32.65 77.1398 33.2 76.3398 33.2C75.5398 33.2 75.0198 32.58 75.0198 31.74C75.0198 30.9 75.5698 30.24 76.3798 30.24C77.1898 30.24 77.7098 30.87 77.7098 31.69M75.5698 31.73C75.5698 32.31 75.8598 32.78 76.3698 32.78C76.8798 32.78 77.1598 32.31 77.1598 31.71C77.1598 31.17 76.8898 30.66 76.3698 30.66C75.8498 30.66 75.5698 31.14 75.5698 31.73Z",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6999 30.29V33.16H81.1799V30.72H80.3999V31.49C80.3999 32.18 80.3399 32.8 79.9199 33.06C79.7999 33.14 79.6099 33.2 79.4099 33.2L79.3499 32.78C79.4799 32.76 79.5899 32.7 79.6599 32.63C79.8599 32.43 79.8899 31.98 79.8899 31.53V30.3H81.7099L81.6999 30.29Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3699 31.69C86.3699 32.65 85.7899 33.2 84.9999 33.2C84.2099 33.2 83.6799 32.58 83.6799 31.74C83.6799 30.9 84.2299 30.24 85.0399 30.24C85.8499 30.24 86.3699 30.87 86.3699 31.69ZM84.2299 31.73C84.2299 32.31 84.5199 32.78 85.0299 32.78C85.5399 32.78 85.8199 32.31 85.8199 31.71C85.8199 31.17 85.5499 30.66 85.0299 30.66C84.5099 30.66 84.2299 31.14 84.2299 31.73Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9799 30.29V30.72H88.8699V33.15H88.3398V30.29H89.9799Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3299 30.29V31.3C92.3299 31.76 92.3199 32.18 92.2999 32.56C92.4499 32.24 92.6399 31.9 92.8199 31.57L93.5799 30.28H94.1099V33.15H93.6299V32.13C93.6299 31.68 93.6299 31.31 93.6699 30.94C93.5299 31.27 93.3399 31.63 93.1599 31.93L92.4399 33.14H91.8599V30.27H92.3399L92.3299 30.29Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.72 30.29V31.3C96.72 31.76 96.71 32.18 96.69 32.56C96.84 32.24 97.03 31.9 97.21 31.57L97.97 30.28H98.5V33.15H98.02V32.13C98.02 31.68 98.02 31.31 98.06 30.94C97.92 31.27 97.73 31.63 97.55 31.93L96.83 33.14H96.25V30.27H96.73L96.72 30.29Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.04 30.32C103.23 30.29 103.49 30.26 103.84 30.26C104.22 30.26 104.5 30.34 104.69 30.49C104.86 30.63 104.97 30.86 104.97 31.13C104.97 31.4 104.89 31.63 104.72 31.78C104.51 31.99 104.18 32.09 103.81 32.09C103.71 32.09 103.62 32.09 103.56 32.07V33.15H103.04V30.32ZM103.56 31.66C103.62 31.68 103.71 31.68 103.81 31.68C104.2 31.68 104.44 31.49 104.44 31.15C104.44 30.83 104.22 30.66 103.86 30.66C103.72 30.66 103.61 30.67 103.56 30.68V31.65V31.66Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.19 30.29L107.67 31.4C107.75 31.59 107.81 31.76 107.87 31.93H107.88C107.92 31.8 107.97 31.61 108.04 31.39L108.42 30.3H108.97L108.4 31.73C108.23 32.15 108.05 32.58 107.85 32.85C107.66 33.08 107.44 33.22 107.14 33.22C107.02 33.22 106.94 33.21 106.87 33.18L106.91 32.76C106.91 32.76 107.01 32.78 107.09 32.78C107.33 32.78 107.49 32.58 107.56 32.41C107.58 32.35 107.58 32.31 107.55 32.26L106.59 30.31H107.18L107.19 30.29Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7 30.29V32.74H112.97L112.94 33.87H112.54L112.51 33.16H110.77L110.74 33.87H110.34L110.32 32.75H110.55C110.66 32.54 110.76 32.33 110.83 32.1C110.92 31.79 110.95 31.44 110.95 31.03V30.28H112.7V30.29ZM111.43 31.17C111.43 31.56 111.39 31.92 111.29 32.22C111.23 32.41 111.15 32.59 111.08 32.73H112.17V30.72H111.42V31.17H111.43Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.43 30.29V31.43H116.64V30.29H117.17V33.15H116.64V31.89H115.43V33.15H114.91V30.29H115.43Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.87 11.46H36.74V44.98H37.87V11.46Z",
    fill: "#A30C33",
    stroke: "#A30C33",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63006 8H0.0600586V26.85H3.63006V8Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.97 11.44H10.69L4.5 19.15L10.73 26.86H14.99L8.85 19.15L14.97 11.44Z",
    fill: "#A30C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6599 11.44H19.3899L13.1899 19.15L19.4199 26.86H23.6899L17.5399 19.15L23.6599 11.44Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0500488 30.4H0.450049V33.72H0.0500488V30.4ZM1.00005 31.96L2.56005 33.72H2.04005L0.540049 31.99L2.00005 30.4H2.49005L1.01005 31.96H1.00005Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30012 30.78H4.09012L4.03012 31.41C3.84012 33.52 3.39012 33.79 2.87012 33.73V33.33C3.11012 33.35 3.51012 33.24 3.66012 31.08L3.71012 30.42H5.70012V33.74H5.30012V30.8V30.78Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84009 33.72V30.4H7.24009V33.06L9.26009 30.4H9.62009V33.72H9.22009V31.06L7.20009 33.72H6.84009Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.99 32.22H11.16V33.72H10.76V30.4H11.16V31.84H12.99V30.4H13.39V33.72H12.99V32.22Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.54 33.72V30.4H14.94V33.06L16.96 30.4H17.32V33.72H16.92V31.06L14.9 33.72H14.54Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 30.4H18.85V33.72H18.45V30.4ZM19.4 31.96L20.9599 33.72H20.44L18.94 31.99L20.4 30.4H20.8899L19.41 31.96H19.4Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.64 30.38H22.99L24.42 33.72H23.99L23.56 32.71H22.05L21.63 33.72H21.22L22.65 30.38H22.64ZM22.2 32.34H23.4L22.8 30.92L22.2 32.34Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26005 36.37H0.450049V39.31H0.0500488V35.99H2.66005V39.31H2.26005V36.37Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 39.32V36C3.99005 36 4.46005 36 4.67005 36C5.62005 36 5.90005 36.51 5.90005 37.03C5.90005 37.55 5.52005 38.07 4.70005 38.07C4.57005 38.07 4.37005 38.07 4.20005 38.05V39.33H3.80005V39.32ZM4.20005 36.38V37.66C4.36005 37.67 4.52005 37.68 4.68005 37.68C5.17005 37.68 5.46005 37.43 5.46005 37.01C5.46005 36.62 5.22005 36.36 4.70005 36.36C4.57005 36.36 4.35005 36.36 4.20005 36.36V36.38Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16998 35.95C9.12998 35.95 9.85998 36.65 9.85998 37.66C9.85998 38.67 9.12998 39.37 8.16998 39.37C7.20998 39.37 6.47998 38.67 6.47998 37.66C6.47998 36.65 7.18998 35.95 8.16998 35.95ZM8.16998 38.99C8.92998 38.99 9.43998 38.41 9.43998 37.66C9.43998 36.91 8.87998 36.33 8.16998 36.33C7.45998 36.33 6.89998 36.89 6.89998 37.66C6.89998 38.43 7.45998 38.99 8.16998 38.99Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0199 38.92C11.0899 38.92 10.4399 38.45 10.4399 37.61C10.4399 36.77 11.0699 36.31 12.0199 36.3V35.96H12.4199V36.3C13.3799 36.3 14.0099 36.78 14.0099 37.61C14.0099 38.44 13.3599 38.92 12.4299 38.92H12.4199V39.36H12.0199V38.92ZM12.0199 38.55V36.68C11.2999 36.68 10.8699 37.03 10.8699 37.61C10.8699 38.23 11.3199 38.55 12.0199 38.55ZM12.4299 36.68V38.55C13.1399 38.55 13.5899 38.23 13.5899 37.61C13.5899 37.03 13.1699 36.68 12.4299 36.68Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 36H16.7201V36.38H15.2501V37.45H16.5801V37.83H15.2501V38.94H16.7701V39.32H14.8501V36Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 38.99C19.98 39.22 19.56 39.36 19.15 39.36C18.15 39.36 17.47 38.69 17.47 37.65C17.47 36.7 18.09 35.94 19.13 35.94C19.56 35.94 19.9 36.06 20.14 36.26L19.95 36.56C19.73 36.4 19.48 36.31 19.13 36.31C18.41 36.31 17.9 36.85 17.9 37.64C17.9 38.43 18.43 38.97 19.2 38.97C19.52 38.97 19.82 38.86 20.05 38.68L20.21 38.98L20.2 38.99Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3201 38.99C23.1001 39.22 22.6801 39.36 22.2701 39.36C21.2701 39.36 20.5901 38.69 20.5901 37.65C20.5901 36.7 21.2101 35.94 22.2501 35.94C22.6801 35.94 23.0201 36.06 23.2601 36.26L23.0701 36.56C22.8501 36.4 22.6001 36.31 22.2501 36.31C21.5301 36.31 21.0201 36.85 21.0201 37.64C21.0201 38.43 21.5501 38.97 22.3201 38.97C22.6401 38.97 22.9401 38.86 23.1701 38.68L23.3301 38.98L23.3201 38.99Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.42 35.95C26.38 35.95 27.11 36.65 27.11 37.66C27.11 38.67 26.38 39.37 25.42 39.37C24.46 39.37 23.73 38.67 23.73 37.66C23.73 36.65 24.44 35.95 25.42 35.95ZM25.42 38.99C26.18 38.99 26.69 38.41 26.69 37.66C26.69 36.91 26.13 36.33 25.42 36.33C24.71 36.33 24.15 36.89 24.15 37.66C24.15 38.43 24.71 38.99 25.42 38.99Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.99 39.32V36C28.18 36 28.65 36 28.86 36C29.81 36 30.09 36.51 30.09 37.03C30.09 37.55 29.71 38.07 28.89 38.07C28.76 38.07 28.56 38.07 28.39 38.05V39.33H27.99V39.32ZM28.39 36.38V37.66C28.55 37.67 28.71 37.68 28.87 37.68C29.36 37.68 29.65 37.43 29.65 37.01C29.65 36.62 29.41 36.36 28.89 36.36C28.76 36.36 28.54 36.36 28.39 36.36V36.38Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67 35.98H32.02L33.45 39.32H33.02L32.59 38.31H31.08L30.66 39.32H30.25L31.68 35.98H31.67ZM31.23 37.94H32.43L31.83 36.52L31.23 37.94Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0500488 41.59H0.450049V44.91H0.0500488V41.59ZM1.00005 43.15L2.56005 44.91H2.04005L0.540049 43.18L2.00005 41.59H2.49005L1.01005 43.15H1.00005Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24007 41.57H4.59007L6.02007 44.91H5.59007L5.16007 43.9H3.65007L3.23007 44.91H2.82007L4.25007 41.57H4.24007ZM3.80007 43.53H5.00007L4.40007 42.11L3.80007 43.53Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72004 41.97H7.51004L7.45004 42.6C7.26004 44.71 6.81004 44.98 6.29004 44.92V44.52C6.53004 44.54 6.93004 44.43 7.08004 42.27L7.13004 41.61H9.12004V44.93H8.72004V41.99V41.97Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.26 44.91V41.59H10.66V44.25L12.68 41.59H13.04V44.91H12.64V42.25L10.62 44.91H10.26Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4099 43.41H14.5799V44.91H14.1799V41.59H14.5799V43.03H16.4099V41.59H16.8099V44.91H16.4099V43.41Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.04 44.91H19.64V43.46C19.47 43.58 19.15 43.72 18.76 43.72C18.23 43.72 17.76 43.44 17.76 42.66V41.59H18.16V42.55C18.16 43.12 18.45 43.34 18.86 43.34C19.18 43.34 19.46 43.21 19.63 43.09V41.6H20.03V44.92L20.04 44.91Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1899 41.59H23.0599V41.97H21.5899V43.04H22.9199V43.42H21.5899V44.53H23.1099V44.91H21.1899V41.59Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2901 43.41H24.4601V44.91H24.0601V41.59H24.4601V43.03H26.2901V41.59H26.6901V44.91H26.2901V43.41Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8301 41.59H28.2301V44.91H27.8301V41.59ZM28.7801 43.15L30.3401 44.91H29.8201L28.3201 43.18L29.7801 41.59H30.2701L28.7901 43.15H28.7801Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3101 41.55C33.2701 41.55 34.0001 42.25 34.0001 43.26C34.0001 44.27 33.2701 44.97 32.3101 44.97C31.3501 44.97 30.6201 44.27 30.6201 43.26C30.6201 42.25 31.3301 41.55 32.3101 41.55ZM32.3101 44.59C33.0701 44.59 33.5801 44.01 33.5801 43.26C33.5801 42.51 33.0201 41.93 32.3101 41.93C31.6001 41.93 31.0401 42.49 31.0401 43.26C31.0401 44.03 31.6001 44.59 32.3101 44.59Z",
    fill: "#808285",
    stroke: "#808285",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7435_11991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117.35,
    height: 37.1,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeroKalinchenko);
export default __webpack_public_path__ + "static/media/logo_hero_kalinchenko.0d73188da076249164de65a0aaeee4fd.svg";
export { ForwardRef as ReactComponent };